import { createContext, createElement, useContext, useEffect, useMemo, useState } from 'react'

interface IIsBusyContext {
  isBusy: boolean
  setIsBusy: React.Dispatch<React.SetStateAction<boolean>>
}

const IsBusyContext = createContext<IIsBusyContext>({} as IIsBusyContext)

export const useIsBusyContext = () => {
  return useContext(IsBusyContext)
}

export const IsBusyContextProvider: React.FC = ({ children }) => {
  const [count, setCount] = useState<number>(0)
  const [isBusy, setIsBusy] = useState<boolean>(false)
  const isBusyValue = useMemo(() => ({ isBusy: isBusy, setIsBusy }), [isBusy, setIsBusy])

  useEffect(() => {
    let newCount = 0
    if (isBusy) {
      newCount = count + 1
    } else if (count > 0) {
      newCount = count - 1
    }

    setCount(newCount)

    if (!isBusy && newCount > 0) {
      setIsBusy(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBusy])

  return createElement(IsBusyContext.Provider, { value: { ...isBusyValue } }, children)
}
